// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a0fa257c","796":"d6df7dae"}[chunkId] + ".chunk.js";
};